import { isHttpErrorWithId } from './is-http-error-with-id';
/**
 * True when a user move was rejected because it must go through the organization switch
 * instead of the accounts "move user" flow (super-admin / dashboard-user moves).
 */
export function isOrganizationMoveRequiresSwitchError(error) {
    return isHttpErrorWithId(error, 403, 'ORGANIZATION_MOVE_REQUIRES_SWITCH');
}
